/**
 * Where the Stake.us affiliate line may appear. Texas and Florida hubs (state and city)
 * only, since both states are open on Stake.us. Never add a hub in an excluded state.
 */
var METRO_HUBS = require('./metro-hubs');

var STATES = ['/texas-poker-rooms', '/florida-poker-rooms'];
var GUIDE = '/guides/how-stake-us-works';

function go(medium, content) {
  return '/go/stake?utm_source=dailytourneys&utm_medium=' + medium + (content ? '&utm_content=' + content : '');
}

function hubEligible(slug) {
  if (STATES.indexOf('/' + slug) >= 0) return true;
  var hub = METRO_HUBS[slug];
  return !!(hub && hub.parent && STATES.indexOf(hub.parent.to) >= 0);
}

module.exports = {
  guide: GUIDE,
  go: go,
  hubEligible: hubEligible,
  hubLine: {
    lead: 'Prefer to play from home? ',
    joinLabel: 'Play Stake.us poker and casino games',
    guideLabel: 'How Stake.us works'
  },
  home: {
    guideLabel: 'New to Stake.us? How Stake Cash works',
    joinLabel: 'Join Stake.us'
  },
  footer: {
    guideLabel: 'How Stake.us works',
    joinLabel: 'Join Stake.us'
  }
};



// WEBPACK FOOTER //
// ./js/stake-placement.js